import { render } from "./AddSystem.vue?vue&type=template&id=63c9d51e"
import script from "./AddSystem.vue?vue&type=script&lang=js"
export * from "./AddSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__